import {Component, OnInit} from '@angular/core';
import {AbstractGamePlayComponent} from "../abstract-game-play.component";
import {GamePlay} from "../../model/game-play";
import {Down} from "../../model/down";
import {PlayType} from "../../model/playType";
import {ODK} from "../../model/odk";
import {DEFAULT_FIRST_DOWN_DISTANCE, DEFAULT_KICKOFF_YARD_LINE, DEFAULT_YARD_LINE} from "../../helpers/distance";
import { TopSectionComponent } from '../../components/top-section/top-section.component';
import { TranslocoModule } from '@ngneat/transloco';

@Component({
    selector: 'app-select-play',
    templateUrl: './select-play-options.component.html',
    styleUrls: ['./select-play-options.component.scss'],
    imports: [TopSectionComponent, TranslocoModule]
})
export class SelectPlayOptionsComponent extends AbstractGamePlayComponent implements OnInit {
  lastGamePlay?: GamePlay
  gamePlay!: GamePlay


  ngOnInit(): void {
    this.gamePlay = this.game.getFirstPendingGamePlay();
    this.lastGamePlay = this.game.getPrecedingGamePlay(this.gamePlay)
    this.gamePlay.yardLine = '-'
    this.gamePlay.distance = 0
  }

  kickoffSelected() {
    this.gamePlay.yardLine = DEFAULT_KICKOFF_YARD_LINE
    this.router.navigate(['game-play', 'kickoff-selection'])
  }

  startOn35Selected() {
    this.gamePlay.yardLine = DEFAULT_YARD_LINE
    this.gamePlay.distance = DEFAULT_FIRST_DOWN_DISTANCE
    this.gamePlay.down = Down.D1
    this.gamePlay.odk = ([PlayType.FGBlock].includes(this.lastGamePlay!.playType!) ? ODK.Offensive : ODK.Defensive)
    this.router.navigate(['game-play'])
  }
}
